module.exports = __webpack_public_path__ + "static/media/undraw_my_app_grf2.aff7ed9d.svg";